<template>
	<div class="tab-header" :class="{ open }">
		<Corridor flex="row">
			<div class="tab-header__left">
				<div class="tab-header__icon">
					<Icon :name="icon" />
				</div>
				<h2 class="tab-header__label">{{ label }}</h2>
			</div>
			<div class="tab-header__right">
				<h2 class="tab-header__value" :class="format">{{ displayValue }}</h2>
				<p class="tab-header__timeframe">per {{ timeframe }}</p>
			</div>
		</Corridor>
	</div>
</template>

<script>
import Corridor from '@/layouts/Corridor'
import Icon from '@/components/Icon'

export default {
	name: 'TabHeader',
	props: {
		icon: String,
		label: String,
		value: Number,
		open: Boolean,
		timeframe: {
			type: String,
			default: 'week'
		},
		format: {
			type: String,
			default: 'number'
		}
	},
	computed: {
		displayValue() {
			switch (this.format) {
				case 'currency':
					return '$' + (this.value / 100).toFixed(2)
				default:
					return this.value
			}
		}
	},
	components: {
		Corridor,
		Icon
	}
}
</script>

<style lang="scss" scoped>
@import '~scss/vars';
@import '~scss/mq';

.tab-header {
	display: flex;
	align-items: center;
	height: 100%;
	user-select: none;

	&__left {
		flex-grow: 1;
		display: flex;
		align-items: center;
	}
	&__right {
		text-align: right;
		color: white;
	}

	&__icon {
		width: 3rem;
		height: 3rem;
		margin-left: -0.875rem;
		color: white;
	}
	&__label {
		margin: 0;
		color: white;
	}

	&__value {
		font-size: 2rem;
		margin: 0;
		&.currency {
			font-weight: bold;
		}
	}
	&__timeframe {
		font-size: 0.875rem;
		margin: -0.25rem 0 0;
	}

	&__icon,
	&__label,
	&__right {
		transition: color $anim-tab-spd;
	}

	&.open &__icon {
		color: $green-65;
	}
	&.open &__label,
	&.open &__right {
		color: $green-44;
	}

	@include mq-max(sm) {
		&__label {
			max-width: 6.5rem;
		}
	}
}
</style>
